import { jsx as _jsx } from "react/jsx-runtime";
import Home from 'pages/Home';
import { Route } from 'react-router-dom';
var HomeRoutes = function () {
    return ([
        _jsx(Route, { path: '/', element: _jsx(Home, {}) })
    ]);
};
export default HomeRoutes;
